import { createContext } from "react";

const filteredContext= createContext();

export default filteredContext;